<template>
  <Dialog
    :title="type === 'add' ? '新增活动' : '修改活动'"
    :visible.sync="dialogVisible"
    width="640px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="活动标题" prop="title">
        <el-input
          v-model.trim="form.title"
          maxlength="100"
          show-word-limit
          placeholder="请输入活动标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="coverImage">
        <UploadFile
          v-model="form.coverImage"
          :limit="1"
          :maxSize="5"
          accept="image/*"
          :fileTypes="['jpg', 'jpeg', 'png', 'gif', 'webp']"
          @input="$refs.formRef && $refs.formRef.validateField('coverImage')"
        ></UploadFile>
      </el-form-item>
      <el-form-item label="活动内容" prop="content">
        <el-input
          type="textarea"
          v-model.trim="form.content"
          :rows="6"
          maxlength="2000"
          show-word-limit
          placeholder="请输入活动内容"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import UploadFile from "@/components/UploadFile";
import {
  addActivity,
  updateActivity,
  getActivityDetail
} from "@/api/content/activity";

const defaultForm = () => ({
  activityId: undefined,
  title: "",
  coverImage: "",
  content: ""
});

export default {
  name: "ActivityForm",
  components: { UploadFile },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      form: defaultForm(),
      rules: {
        title: [
          { required: true, message: "请输入活动标题", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "标题长度为1~100个字符",
            trigger: "blur"
          }
        ],
        coverImage: [
          { required: true, message: "请上传封面", trigger: "change" }
        ],
        content: [
          { required: true, message: "请输入活动内容", trigger: "blur" },
          { max: 2000, message: "内容不能超过2000个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    async open(type, row = {}) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit" && row.activityId != null) {
        try {
          const result = await getActivityDetail(row.activityId);
          const data = (result && result.data) || row;
          this.form = {
            activityId: data.activityId,
            title: data.title || "",
            coverImage: data.coverImage || "",
            content: data.content || ""
          };
        } catch (e) {
          this.cancel();
          return;
        }
      } else {
        this.form = defaultForm();
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      const request = this.form.activityId ? updateActivity : addActivity;
      try {
        await request({ ...this.form });
        this.$message.success(this.form.activityId ? "修改成功" : "新增成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Activity/ActivityForm.vue